<div class="info-tile-container">
    <app-info-tile
        [infoName]="'Total Mortalities'"
        [infoValue]="mortalityStats.totalMortalities"
    >
    </app-info-tile>

    <app-info-tile
        [infoName]="'Mortality Rate'"
        [infoValue]="mortalityStats.mortalityRate + '%'"
    >
    </app-info-tile>

    <app-info-tile
        [infoName]="'Total Records'"
        [infoValue]="mortalityStats.records"
    >
    </app-info-tile>
</div>
